rs.module("controls/components/event-banner",

    [
        "ui/framework/client-templates",
        "common/visibility"
    ],

    function (clientTemplates, visibility) {

        var _jsSelectors;
        var _collapsedToggleClass;
        var _clientTemplateKeys;
        var _messageTypes;
        var _httpHeaderNames;
        var _httpCookieNames;

        //
        // Initialize the event banner
        //
        function initialize(
            jsSelectors,
            messageTypes,
            collapsedToggleClass,
            clientTemplateKeys,
            httpHeaderNames,
            httpCookieNames,
            httpCookieDomain
        ) {

            _jsSelectors = jsSelectors;
            _messageTypes = messageTypes;
            _collapsedToggleClass = collapsedToggleClass;
            _clientTemplateKeys = clientTemplateKeys;
            _httpHeaderNames = httpHeaderNames;
            _httpCookieNames = httpCookieNames;

            // Listen for show\hide clicks
            $.js(_jsSelectors.toggle, { required: false }).click(_onToggle);

            // Listen for form submission, to add a cookie to the request
            $.js(_jsSelectors.approvalForm, { multiple: true, required: false }).submit(function () {
                Cookies.set(_httpCookieNames.approveWarnings, 'true', { secure: true, domain: httpCookieDomain, path: '' /* this page only */ })
            })

            // look for the existence of any delayed error messages (sessionStorage)
            if (sessionStorage.delayedErrorMessages) {
                addErrorMessages(...JSON.parse(sessionStorage.delayedErrorMessages));
                sessionStorage.removeItem("delayedErrorMessages");
            }

            // look for the existence of any delayed info messages (sessionStorage)
            if (sessionStorage.delayedInfoMessages) {
                addInformationalMessages(...JSON.parse(sessionStorage.delayedInfoMessages));
                sessionStorage.removeItem("delayedInfoMessages");
            }
        }

        //
        // Add warnings to the banner
        // 
        function addWarnings(warningGroups, originatingRequest, successCallbacks, failCallbacks) {

            // Content accumulator
            var detailContent = '';

            // Render each of the individual warning groups for displaying in the banner.
            warningGroups.forEach(warningGroup => {
                detailContent += clientTemplates.render(_clientTemplateKeys.warningDetail, { "warnings": warningGroup.Warnings, "approvalToken": warningGroup.ApprovalToken });
            });

            // Render the banner itself, containing each renderered warning group.
            var eventBanner = $(clientTemplates.render(_clientTemplateKeys.eventBanner,
                {
                    "messageType": _messageTypes.warnings,

                    // Render detail template and pass html for all of the warning groups to event banner template.
                    "detailContent": detailContent
                }));

            // Hook up a click handler for each warning approval button in the the returned event banner.
            $(eventBanner).js(_jsSelectors.approval, { multiple: true })
                .on('click', function () {

                    $(this).prop("disabled", true);

                    var approveSettings = {
                        url: originatingRequest.settings.url,
                        type: originatingRequest.settings.type,

                        headers: {
                            [_httpHeaderNames.approvalToken]: this.value
                        }
                    }

                    // Make the call to approve these warnings.
                    $.ajax(
                        approveSettings
                    ).done(function (data, status, request) {

                        // Remove warning messages.  If the approval request resulted in warnings, this done() would not have gotten called, so it's safe to clear here.
                        removeWarningMessages();

                        // Denote for callers that warnings have been approved.
                        request.warningsApproved = true;

                        // Adding each original success callback as a done handler will immediately execute them.
                        successCallbacks.forEach(callback => request.done(callback));
                    }).fail(function (request) {

                        // Adding each original fail callback as a fail handler will immediately execute them.
                        failCallbacks.forEach(callback => request.fail(callback));
                    }).always(function () {

                        $(this).prop("disabled", false);
                    });
                });

            $.js(_jsSelectors.eventBannerContainer).html(eventBanner);

            // Re-hook up toggle click event
            $.js(_jsSelectors.toggle, { required: false }).click(_onToggle);

            // Show event banner
            showEventBanner();
        }

        //
        // Add Errors to EventBanner
        //
        function addErrorMessages(...messages) {
            addMessages(_messageTypes.errors, ...messages);
        }

        //
        // Add Errors to be displayed on the next page load
        // 
        function addDelayedErrorMessages(...messages) {
            sessionStorage.delayedErrorMessages = JSON.stringify(messages);
        }

        //
        // Add Info to EventBanner
        //
        function addInformationalMessages(...messages) {
            addMessages(_messageTypes.messages, ...messages);
        }

        //
        // Add Info to be displayed on the next page load
        // 
        function addDelayedInformationalMessages(...messages) {
            sessionStorage.delayedInfoMessages = JSON.stringify(messages);
        }

        // Render and display EventBanner with messages
        function addMessages(messageType, ...messages) {

            var eventBanner = $(clientTemplates.render(_clientTemplateKeys.eventBanner,
                {
                    "messageType": messageType,
                    "messageCount": messages.length,

                    // render detail template and pass html to event banner template
                    "detailContent": clientTemplates.render(_clientTemplateKeys.detail, { "messages": messages })
                }));

            $.js(_jsSelectors.eventBannerContainer).html(eventBanner);

            // Re-hook up toggle click event
            $.js(_jsSelectors.toggle, { required: false }).click(_onToggle);

            // Show event banner
            showEventBanner();
        }

        //
        // Remove Errors from EventBanner
        //
        function removeErrorMessages() {
            removeMessages(_messageTypes.errors);
        }

        //
        // Remove Warnings from EventBanner
        //
        function removeWarningMessages() {
            removeMessages(_messageTypes.warnings);
        }

        //
        // Removes all business messages from EventBanner
        // 
        function removeAllMessages() {
            var detail = $.js(_jsSelectors.detail, { required: false });

            if (detail) {

                // remove messages
                detail.find("li").remove();

                // Hide empty banner
                hideEventBanner();
            }
        }

        //
        // Remove Info from EventBanner
        //
        function removeInformationalMessages() {
            removeMessages(_messageTypes.messages);
        }

        // Remove the given message type from the EventBanner
        function removeMessages(messageType) {

            var detail = $.js(_jsSelectors.detail, { required: false });

            if (detail.data("messagetype") == messageType) {

                // remove messages
                detail.find("li").remove();

                // Hide empty banner
                hideEventBanner();
            }
        }

        // Show the event banner
        function showEventBanner() {
            visibility.show($.js(_jsSelectors.eventBannerContainer));
        }

        // Hide the event banner
        function hideEventBanner() {
            visibility.hide($.js(_jsSelectors.eventBannerContainer));
        }

        // The user is clicking to expand or collapse the detail
        function _onToggle() {

            // Toggle details with slide effect
            $.js(_jsSelectors.detail).slideToggle(500);

            // Add class to toggle to rotate it
            $.js(_jsSelectors.toggle).toggleClass(_collapsedToggleClass);
        }

        // Function to return the event banner html
        function eventBannerHtml() {
            return $.js(_jsSelectors.eventBannerContainer);
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            addErrorMessages: addErrorMessages,
            addDelayedErrorMessages: addDelayedErrorMessages,
            addInformationalMessages: addInformationalMessages,
            addDelayedInformationalMessages: addDelayedInformationalMessages,
            addWarnings: addWarnings,
            removeErrorMessages: removeErrorMessages,
            removeInformationalMessages: removeInformationalMessages,
            removeWarningMessages: removeWarningMessages,
            removeAllMessages: removeAllMessages,
            html: eventBannerHtml
        };

        return exports;
    }
);